import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { type FeedUserInfo } from '@src/services/interface';
import { type callAppParmam } from '@src/services/myInterface';
import { jumpPageUrl, getQuery } from '@src/utils';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { type FeedFlowItem } from '@src/services/interface';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';

type UserInfoProps = {
    content?: {
        author?: FeedUserInfo | null;
        location?: FeedFlowItem['location'];
        ipLocation?: FeedFlowItem['ipLocation'];
        ctime?: FeedFlowItem['ctime'];
        callAppData?: callAppParmam;
    };
};

// 日期格式转换 格式为2022-10-01 00:00
const timeFormat = (timeString: string) => {
    const ctimeSplit = timeString?.split(' ') || [];
    const yearSplit = (ctimeSplit?.[0] && ctimeSplit[0].split('-')) || [];
    const monthSplit = (ctimeSplit?.[1] && ctimeSplit[1].split(':')) || [];
    const year =
        (yearSplit?.[0]?.slice(2) &&
            yearSplit?.[1] &&
            yearSplit?.[2] &&
            `${yearSplit?.[0].slice(2)}-${yearSplit[1]}-${yearSplit[2]}`) ||
        '';
    const month = (monthSplit?.[0] && monthSplit?.[1] && `${monthSplit[0]}:${monthSplit[1]}`) || '';

    return {
        date: year || '',
        time: month || '',
    };
};

const UserInfo = ({ content = {} }: UserInfoProps) => {
    const { author, location, ipLocation, ctime, callAppData } = content;
    const address = location || ipLocation || '';
    const dateTime = timeFormat(ctime || '');
    const guid = author?.guid || '';
    const userId = getQuery(window.location.href, 'userId') || '';

    const jumpHandle = () => {
        volcengineAndH5Statistics({
            behavior: 'action',
            type: 'sharepage_link_button',
            button_name: 'a',
            user_id: userId,
        });
        jumpPageUrl('personal', guid);
    };
    const wxLaunchHackData = {
        callAppConfig: callAppData,
        statisticsConfig: {
            behavior: 'action',
            type: 'sharepage_app_start',
            button_name: 'a',
            user_id: userId,
        },
    };

    return (
        <div className={styles.articleUserInfo}>
            <div className={styles.feedHeadBox}>
                {author?.avatar && (
                    <div className={styles.left} onClick={jumpHandle}>
                        <img className={styles.pic} src={formatImageWebpAuto(author.avatar, 100, 100)} alt="" />
                    </div>
                )}
                <div className={styles.right}>
                    <div className={styles.titleInfo}>
                        <div className={styles.title}>{author?.nickname}</div>
                        {author?.label?.length ? (
                            <div className={styles.userBref}>
                                {author.label.map((item) => (
                                    <span key={item} className={styles.userMark}>
                                        {item}
                                    </span>
                                ))}
                            </div>
                        ) : null}
                        <div className={styles.info}>
                            {address && <div className={styles.address}>{address}</div>}
                            {address && <div className={styles.line} />}
                            <div className={styles.year}>{dateTime.date}</div>
                            {dateTime.time && <div className={styles.line} />}
                            <div className={styles.time}>{dateTime.time}</div>
                        </div>
                    </div>
                    <div className={styles.follow}>
                        关注
                        <WxLaunchHack content={wxLaunchHackData} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(UserInfo);
